
<template>
<div id="app" >
  <v-app style="background: #323232;">
    <div class="breadcrumbs" id="breadcrumbs" >
        <button class="breadcrumb-home breadcrumb-btn" style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);" @click="$store.state.showTimeline = true; $store.state.showMap = false" aria-label="Go to main timeline">
            <p style=""><i class="arrow left" style="width:0.8rem;height:0.8rem"></i></p>
            <p>Back</p>
        </button>

        
    </div>

    <div id="map-container" class="map-container">
        <div id="map-screen">
            <img id="map-img" v-bind:src="require(`@/assets/art/map_full.jpg`)" />
            
            <button @click="switchText(sourceData)" id="yellow-marker">
               <img class="map-marker" id="arrow" v-bind:src="getMarker()" />
            </button>
            
            
        </div>
    </div>
    <div class="map-info">
        <div class="year-label">Year : {{ year }}</div>
        <div class="event-container" id="event-container">
            <div class="separator"><img v-bind:src="require(`@/assets/ui/info_location_pin.png`)" class="marker-icon"> {{ locLabel }}</div>
            <p v-html="eventText"> </p>
        </div>

        <div class="zoom-controls">
            <button @click="zoom(false)" class="map-zoom-btn"> + </button>
            <button @click="zoom(true)" class="map-zoom-btn"> - </button>
        </div>
    </div>

  </v-app>
</div>
</template>

<script>
    import data from '@/content/content.js';
    import mapData from '@/content/map.js';
    import Panzoom from '@panzoom/panzoom';

    export default {
    name: 'Map',

    props: ['year', 'id'],

    methods: {

        getEventText() {
            this.sourceData = this.json.find(item => item.id === this.id);
            this.eventText = this.sourceData.event;
            this.locLabel = this.sourceData.location;
            this.otherEvents = this.json.filter(item => ((item.year === this.year) &&  item.event != this.eventText));
            this.eventTexts = [];
        },

        getFileName(name){
            var img = name;
            img = img.replace(/\s+/g, '-').toLowerCase();
            return img;
        },

        getPrimaryMarkers() {
            const marker = document.getElementById("yellow-marker");
            for (const property in this.coords) {
                if(this.locLabel.includes(this.coords[property].location))
                {
                    marker.style = this.coords[property].coordinates;
                    this.currEvent = this.coords[property];
                    break;
                }
            }
        },

        getMarker() {
            const marker = document.getElementById('yellow-marker');
            const markerImg = document.getElementById('arrow');

            if(this.currEvent.arrow)
            {
                markerImg.style = 'max-width: 10rem; max-height: 10rem';
                switch(this.currEvent.arrow) {
                    case 'west':
                        marker.style.transform = 'rotate(180deg)'
                        break;
                    case 'south':
                        marker.style.transform = 'rotate(84deg)'
                        break;
                }
                return require(`@/assets/ui/map_arrow.png`);
            }
            else {
                return require(`@/assets/ui/map_pin_yellow.png`);
            }
        },

        getSecondaryMarkers() {
            for (let i = 0; i < this.otherEvents.length; i++)
            {
                for (let j = 0; j < this.coords.length; j++)
                {
                    if(this.otherEvents[i].location.includes(this.coords[j].location))
                    {
                        let marker = document.getElementById('red-marker-' + i);
                        let coord = this.coords[j].coordinates;
                        marker.style = 'position: absolute;' + coord[0];
                    }
                }
            }
        },

        getTargetCoords() {

            let mapRect = document.getElementById('map-screen').getBoundingClientRect();
            let point = { x: 0, y: 0};
            let percentX = 0;
            let percentY = 0;
            let zoomOffset = { x: 0, y: 0};

            // get percent values from data
            for (const property in this.coords) {
                if(this.locLabel.includes(this.coords[property].location))
                {
                    console.log(this.coords[property].location)
                    let str = this.coords[property].coordinates[0];

                    percentX = Number(str.substring(
                        str.indexOf("l") + 6,
                        str.lastIndexOf("%")
                    ));
                    percentY = Number(str.substring(
                        str.indexOf(" ") + 1,
                        str.indexOf("%")
                    ));

                    if(this.coords[property].zoomOffset){
                        zoomOffset=this.coords[property].zoomOffset
                    }
                    break;
                }
            }

            // shifting to cartesian system
            let modX = (50 - percentX+zoomOffset.x) / 100;
            let modY = (50 - percentY+zoomOffset.y) / 100;

            point.x = modX * mapRect.width / 2;
            point.y = modY * mapRect.height / 2;

            return point;
        },
        getDefaultZoom(){
            for (const property in this.coords) {
                if(this.locLabel.includes(this.coords[property].location))
                {
                    return this.coords[property].zoom||3;
                }
            }
            return 1
        },

        switchText(object) {
            this.eventText = object.event;
            this.locLabel = object.location;
        },

        zoom(out) {

            if(out)
            {
                if(this.zScale != this.zMin)
                {
                    this.zScale -= 0.5;
                }      
                this.panzoomInstance.zoom(this.zScale, { animate: true });
            }
            else{
                if(this.zScale != this.zMax)
                {
                    this.zScale += 0.5;
                }
                this.panzoomInstance.zoom(this.zScale, { animate: true });
            }
        },
    },

    mounted: function () {
        this.getEventText();
        this.getPrimaryMarkers();
        const elem = document.getElementById('map-screen');

        setTimeout(() => {

            this.panzoomInstance = Panzoom(elem, {
                contain: 'outside'
            });

            setTimeout(() => {
                this.zScale = this.getDefaultZoom();
                this.panzoomInstance.zoom(this.zScale);

                setTimeout(() => {
                    let coords = this.getTargetCoords();
                    this.panzoomInstance.pan( coords.x, coords.y );

                }, 100);
            }, 100);
        }, 100);
    },  

    updated: function() {
        this.getSecondaryMarkers();
    },

    data() {
        return {
            json: data.events,
            coords: mapData.fullMapCoords,
            sourceData: {},
            currEvent: {},
            eventText: "",
            locLabel: "",
            fileName: "",
            otherEvents: "",
            panzoomInstance: {},
            zScale: 1,
            zMax: 3,
            zMin: 1,
        }
    }
}
</script>

<style lang="css">
</style>